import { render, staticRenderFns } from "./MyBoardWrite.vue?vue&type=template&id=0c66415e&scoped=true&"
import script from "./MyBoardWrite.vue?vue&type=script&lang=js&"
export * from "./MyBoardWrite.vue?vue&type=script&lang=js&"
import style0 from "./MyBoardWrite.vue?vue&type=style&index=0&id=0c66415e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c66415e",
  null
  
)

export default component.exports